import React, { useState, useEffect } from "react";
import "./UploadFile.css";
import { getGridcoFileTypes, uploadGridcoFile, getGridcoUploadedFile } from "../../Rest_api/RestApi";
import PaginationTable from "../../components/Table.tsx";

const GridcoUploadFile = () => {
  const [selectedFileType, setSelectedFileType] = useState("");
  const [uploadedFile, setUploadedFile] = useState(null);
  const [fileDescription, setFileDescription] = useState("");
  const [files, setFiles] = useState([]);
  const [selectedDate, setSelectedDate] = useState("");
  const [fileTypeList, setFileTypeList] = useState([]);
  const [loading, setLoading] = useState(true);

  const columnNames = ["Uploaded At", "Type", "Date", "File Link", "Description"];
  const columnKeys = ["uploaded_at", "type", "user_date", "file_url", "description"];

  useEffect(() => {
    const fetchFileTypes = async () => {
      try {
        const response = await getGridcoFileTypes();
        setFileTypeList(response || []);
        setLoading(false);
      } catch (error) {
        console.error("Error fetching file types:", error);
        setLoading(false);
      }
    };

    fetchFileTypes();
    getFiles();
  }, []);

  const getFiles = async () => {
    try {
      const res = await getGridcoUploadedFile();
      setFiles(res);
    } catch (error) {
      console.error("Error fetching uploaded files:", error);
    }
  };

  const handleFileTypeChange = (event) => {
    setSelectedFileType(event.target.value);
  };

  const handleFileUpload = (event) => {
    const file = event.target.files?.[0];
    if (file) {
      setUploadedFile(file);
    }
  };

  const handleDateChange = (event) => {
    setSelectedDate(event.target.value);
  };

  const handleDescriptionChange = (event) => {
    setFileDescription(event.target.value);
  };

  const handleSubmit = async (event) => {
    event.preventDefault();

    if (!selectedDate) {
      alert("Please select a date before submitting!");
      return;
    }
    if (!selectedFileType) {
      alert("Please select a file type before uploading!");
      return;
    }
    if (!uploadedFile) {
      alert("Please upload a file before submitting!");
      return;
    }

    const formData = new FormData();
    formData.append("file", uploadedFile);
    formData.append("date", selectedDate);
    formData.append("type_name", selectedFileType);
    formData.append("description", fileDescription);

    try {
      await uploadGridcoFile(formData);
      alert(`File "${uploadedFile.name}" submitted successfully on ${selectedDate} as "${selectedFileType}"!`);
      getFiles(); // Refresh the file list
    } catch (error) {
      console.error("Error uploading file:", error);
      alert("Error uploading file. Please try again.");
    }

    // Reset form state
    setSelectedFileType("");
    setUploadedFile(null);
    setFileDescription("");
    setSelectedDate("");
  };

  return (
    <div className="page-container">
      {/* <div>Temeporarly Disabled on QA</div> */}

       <>
      <div className="header">
        <h1>Upload Form</h1>
      </div>
      <form onSubmit={handleSubmit} id="gridco-upload" className="section">
        <div className="taskbar">
          <div className="date">
            <label>
              Select Date:
              <input type="date" value={selectedDate} onChange={handleDateChange} />
            </label>
          </div>
          <div className="select">
            <label>
              Select File Type:
              {loading ? (
                <p>Loading file types...</p>
              ) : (
                <select
                  className="file-type-dropdown"
                  value={selectedFileType}
                  onChange={handleFileTypeChange}
                >
                  <option value="" disabled>
                    Select File Type
                  </option>
                  {fileTypeList.map((fileType, index) => (
                    <option key={index} value={fileType}>
                      {fileType}
                    </option>
                  ))}
                </select>
              )}
            </label>
          </div>
          <div className="upload-section">
            <label className="button-upload">
              Upload File:
              <input
                type="file"
                style={{ display: "none" }}
                onChange={handleFileUpload}
              />
            </label>
            {uploadedFile && (
              <p className="uploaded-file-name">
                Uploaded File: {uploadedFile.name}
              </p>
            )}
          </div>

          <div className="description-section">
            <label className="description-label">
              File Description:
              <input
                type="text"
                value={fileDescription}
                onChange={handleDescriptionChange}
                placeholder="Enter file description"
                className="description-input"
              />
            </label>
          </div>

          <div className="submit-section">
            <button type="submit" className="submit-button">
              Submit
            </button>
          </div>
        </div>
      </form>
      <PaginationTable
        columnNames={columnNames}
        columnKeys={columnKeys}
        data={files.reverse()}
        ITEMS_PER_PAGE={15}
        hyperlinkColumns={{ file_url: "file_url" }}
        hyperlinkText="View File"
      /></> 
    </div>
  );
};

export default GridcoUploadFile;
